import { Action } from '@ngrx/store';
import { ProductReservation } from '@vestiaire/api-sdk-angular';

export enum ReservationActionTypes {
  CheckReservation = '[Reservation] Check reservation status',
  CheckReservationSuccess = '[Reservation] Reservation checked',
  CheckReservationFailure = '[Reservation] Failed to check reservation',
  CancelReservation = '[Reservation] Cancel reservation',
  ClearReservation = '[Reservation] Clear reservation'
}

export class CheckReservation implements Action {
  readonly type = ReservationActionTypes.CheckReservation;
  constructor(public payload: { productId: string }) {}
}

export class CheckReservationSuccess implements Action {
  readonly type = ReservationActionTypes.CheckReservationSuccess;
  constructor(public payload: { productId: string; reservation: ProductReservation }) {}
}

export class CheckReservationFailure implements Action {
  readonly type = ReservationActionTypes.CheckReservationFailure;
}

export class CancelReservation implements Action {
  readonly type = ReservationActionTypes.CancelReservation;
  constructor(public payload: { productId: string }) {}
}

export class ClearReservation implements Action {
  readonly type = ReservationActionTypes.ClearReservation;
}

export type ReservationActionsUnion =
  | CheckReservation
  | CheckReservationSuccess
  | CheckReservationFailure
  | CancelReservation
  | ClearReservation;
